export const name = 'stickyToComponent' as const
